import * as yup from "yup";

export const prescheduledRecurringEventTimingSchema = yup.object({
  durationMinutes: yup.number().required().label("Duration (minutes)"),
  seriesStartsAt: yup.string().required().label("Series Start Date"),
  recurrenceRules: yup.array(yup.string().required())
    .label("Recurrence Rules")
    .required(),
  timezone: yup.string().required(),
});

export type PrescheduledRecurringEventTimingFormSchema = yup.InferType<typeof prescheduledRecurringEventTimingSchema>;
